globalThis.Vector2 = class Vector2 {
  constructor(x, y) {
    this.x = x || 0;
    this.y = y || 0;
  }

  toString() {
    return `${this.x}x${this.y}`;
  }

  static fromString(str) {
    const [x, y] = str.split("x");
    return new Vector2(Number(x), Number(y));
  }

  clone() {
    return new Vector2(this.x, this.y);
  }

  apply(other) {
    this.x = other.x;
    this.y = other.y;
    return this;
  }

  distance(other) {
    const xdiff = this.x - other.x;
    const ydiff = this.y - other.y;
    return Math.sqrt(Math.pow(xdiff, 2) + Math.pow(ydiff, 2));
  }

  add(other) {
    this.x += other.x;
    this.y += other.y;
    return this;
  }

  sub(other) {
    this.x -= other.x;
    this.y -= other.y;
    return this;
  }

  mul(by) {
    this.x *= by;
    this.y *= by;
    return this;
  }

  div(by) {
    this.x /= by;
    this.y /= by;
    return this;
  }

  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    return this;
  }

  static sum(array) {
    const result = new Vector2();
    for (const vec of array) if (vec) result.add(vec);
    return result;
  }

  static avg(array) {
    const result = new Vector2();
    let count = 0;
    for (const vec of array)
      if (vec) {
        result.add(vec);
        count++;
      }
    if (count) result.div(count);
    return result;
  }
};
